module.exports = __webpack_public_path__ + "static/media/xmark-bold.9246deb5.svg";